module.exports = __webpack_public_path__ + "static/media/nr.d16edc69.svg";